import {
  all, call, put, take,
} from 'redux-saga/effects';
import {
  compact, compose, get, isEmpty, map,
} from 'lodash/fp';

import * as adminServices from '../admin/services';
import { FIREBASE_REF } from '../common/constants';
import * as errorActions from '../errors/actions';
import firebase from '../common/firebase';
import * as newslettersActions from '../newsletters/actions';
import * as services from './services';
import * as actions from './actions';

export function* sendNewsletterNotification() {
  while (true) {
    try {
      const action = yield take(actions.SEND_NEWSLETTER_NOTIFICATION_REQUEST);

      const { newsletter, sid, targets } = action.payload;

      yield call(adminServices.fetchSchoolAdminRelationships, { sid });

      const gcids = compose(
        compact,
        map(target => get('id', target.primaryGuardian)),
      )(targets);

      const lastSendAt = yield call(firebase.firestore.FieldValue.serverTimestamp);

      const ref = yield call(firebase.firestore.doc, `${FIREBASE_REF}/school-newsletters/${newsletter.id}`);

      yield all(compact([
        !isEmpty(targets) && call(services.sendSMS, {
          gcids,
          title: newsletter.title,
          nid: newsletter.id,
          sid,
        }),
        call(
          firebase.firestore.updateDocument,
          ref,
          { lastSendAt },
        ),
      ]));

      yield put(actions.sendNewsletterNotificationSuccess());
    } catch (error) {
      yield put(actions.sendNewsletterNotificationFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

export function* resendNewsletterNotification() {
  while (true) {
    try {
      const action = yield take(actions.RESEND_NEWSLETTER_NOTIFICATION_REQUEST);

      const { newsletter, sid, targets } = action.payload;

      yield call(adminServices.fetchSchoolAdminRelationships, { sid });

      const gcids = compose(
        compact,
        map(target => get('id', target.primaryGuardian)),
      )(targets);

      const lastSendAt = yield call(firebase.firestore.FieldValue.serverTimestamp);

      const ref = yield call(firebase.firestore.doc, `${FIREBASE_REF}/school-newsletters/${newsletter.id}`);


      yield all(compact([
        !isEmpty(targets) && call(services.resendSMS, {
          gcids,
          title: newsletter.title,
          nid: newsletter.id,
          sid,
        }),
        call(
          firebase.firestore.updateDocument,
          ref,
          { lastSendAt },
        ),
      ]));

      const timeStamp = yield call(() => new Date());

      yield put(newslettersActions.updateNewsletters({ lastSendAt: { toDate: () => timeStamp }, nid: newsletter.id }));

      yield put(actions.resendNewsletterNotificationSuccess());
    } catch (error) {
      yield put(actions.resendNewsletterNotificationFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
